<template>
  <div class="menubox" :class="path == '/dataindicators' ? 'bg' : ''">
    <!-- <img src="../../assets/images/69A3A3C4-D4DE-47cb-A411-9CE445F9E097.png" style="opacity:0.8" alt=""> -->
    <div style="width:1200px;min-width:1200px;margin:0 auto;">
      <div class="dis-flx al-c" style="height:100px;">
        <div class="dis-flx al-c">
          <img src="../../assets/images/zhihelogo.png" alt="" class="logo" />
          <!-- <p class="bd_tit">致和空间服务平台</p> -->
        </div>
        <div class="tabbox " @click.stop="handleSelect">
          <el-menu class="" :default-active="onRoutes"
            :class="path == '/dataindicators' ? 'el-menu-bg' : 'el-menu-demo'" mode="horizontal" @select="handleSelect"
            active-text-color="#3E79F6" text-color="#3E4F57" router>
            <el-menu-item index="/"><span>首页</span></el-menu-item>
            <el-menu-item index="/newDtPage"><span>资讯</span></el-menu-item>
            <!-- <el-menu-item index="/personPage"><span>专业人才</span></el-menu-item>
            <el-menu-item index="/page"><span>仪器仪表</span></el-menu-item>
            <el-menu-item index="/checkoutPage"><span>创新平台</span></el-menu-item>
            <el-menu-item index="/investComPage"><span>投资机构</span></el-menu-item> -->
            <el-menu-item index="/spacePage"><span>办公</span></el-menu-item>
            <el-menu-item index="/businessPage"><span>商业</span></el-menu-item>
            <el-menu-item index="/publishSpace"><span>发布房源</span></el-menu-item>
            <el-menu-item index="/findAddress"><span>委托选址</span></el-menu-item>
            <el-menu-item index="/aboutUs"><span>关于我们</span></el-menu-item>
            <!-- <el-menu-item index="/newDtPage"><span>最新动态</span></el-menu-item>
            <el-menu-item index="/zcFgPage"><span>政策法规</span></el-menu-item>
            <el-menu-item index="/mapIndex"><span>创新资源地图</span></el-menu-item> -->
            <el-menu-item style="margin-left: 100px;">
              <el-button v-if="userName == ''" class="btn" @click="dialogFormVisible = true">登录</el-button>
              <el-dropdown v-else>
                <div class="dis-flx al-c loginHead">
                  <img src="../../assets/images/wode.png">
                  <!-- <span>{{userName}}</span> -->
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="jump">个人中心</el-dropdown-item>
                  <el-dropdown-item @click.native="loginOut">退出登录</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </el-menu-item>
          </el-menu>
          <!-- <div class="loginbox dis-flx al-c"> -->
            
            <!-- <el-tooltip class="item" effect="dark" content="创新需求登记" placement="bottom">
              <img class="cur-poi" src="../../assets/images/Group214.png" @click="jumpMap" alt="" />
            </el-tooltip> -->
            <!-- <img class="cur-poi ml-20" src="../../assets/images/我的.png" alt="" /> -->
          <!-- </div> -->
        </div>
        
      </div>
    </div>
    <loginDialog @login="login" @register="register" @forgetPassword="forgetPassword"
      :dialogFormVisible.sync="dialogFormVisible"></loginDialog>
    <registerDialog :dialogFormVisibleTwo.sync="dialogFormVisible2"></registerDialog>
    <forgetPasswordDialog :dialogFormVisibleThree.sync="dialogFormVisible3"></forgetPasswordDialog>
  </div>
</template>

<script>
  import loginDialog from '@/components/login/login.vue'
  import registerDialog from '@/components/login/register.vue'
  import forgetPasswordDialog from '@/components/forgetPassword/index.vue'
  import {
    logout
  } from "@/api/login";

  export default {
    components: {
      loginDialog,
      registerDialog,
      forgetPasswordDialog
    },
    data() {
      return {
        activeIndex: "/",
        isActive: true,
        activeName: "first",
        newscroll: 0,
        path: "",
        dialogFormVisible: false,
        dialogFormVisible2: false,
        dialogFormVisible3: false,
        userName: ''
      };
    },
    computed: {
      onRoutes() {
        const route = this.$route;
        const {
          meta,
          path
        } = route;
        // 在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
        // meta中 有activeMenu 字段的子页面，都会显示高亮
        console.log(path, 'pathpathpath');
        this.path = route.path;
        // console.log(meta);
        if (meta.activeMenu) {
          // console.log(meta);
          return meta.activeMenu;
        }
        let newPath = ''
        if (path == '/page') {
          newPath = '/page'
        } else if (path == '/pageDetail') {
          newPath = '/page'
        } else if (path == '/checkoutPage') {
          newPath = '/checkoutPage'
        } else if (path == '/checkPageDetail') {
          newPath = '/checkoutPage'
        } else if (path == '/personPage') {
          newPath = '/personPage'
        } else if (path == '/professionPerDetail') {
          newPath = '/personPage'
        } else if (path == '/investComPage') {
          newPath = '/investComPage'
        } else if (path == '/aboutUs') {
          newPath = '/aboutUs'
        } else if (path == '/spacePage') {
          newPath = '/spacePage'
        } else if (path == '/spacePageDetail') {
          newPath = '/spacePage'
        } else if (path == '/pageBuildingDetail') {
          newPath = '/spacePage'
        } else if (path == '/businessPage') {
          newPath = '/businessPage'
        } else if (path == '/businessPageDetail') {
          newPath = '/businessPage'
        } else if (path == '/pageBusinessBuildingDetail') {
          newPath = '/businessPage'
        } else if (path == '/publishSpace') {
          newPath = '/publishSpace'
        } else if (path == '/findAddress') {
          newPath = '/findAddress'
        } else if (path == '/newDtPage') {
          newPath = '/newDtPage'
        } else if (path == '/newDtPageDetail') {
          newPath = '/newDtPage'
        } else if (path == '/zcFgPage') {
          newPath = '/zcFgPage'
        } else if (path == '/zcFgPageDetail') {
          newPath = '/zcFgPage'
        } else if (path == '/mapIndex') {
          newPath = '/mapIndex'
        } else {
          newPath = '/'
        }

        return newPath;
      }
    },
    mounted() {
      if (localStorage.getItem('userInfo')) {
        this.userName = JSON.parse(localStorage.getItem('userInfo')).name
      }
    },
    destroyed() {},
    methods: {
      loginOut() {
        this.$confirm('确认退出登录？')
          .then(_ => {
            let data = {}
            logout(data).then(res => {
          console.log(res)
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: '退出登录成功'
            });
            localStorage.removeItem('token')
            localStorage.removeItem('userInfo')
            this.userName = ''
          } else {
            this.$message({
              type: "error",
              message: res.error_description
            });
          }
        });
            done();
          })
          .catch(_ => {});
      },
      register() {
        this.dialogFormVisible = false
        this.dialogFormVisible2 = true
        console.log(this.dialogFormVisible2)
      },
      forgetPassword() {
        this.dialogFormVisible = false
        this.dialogFormVisible3 = true
      },
      handleSelect(key, keyPath) {
        this.$emit("change", key);
        this.$emit("changepage", keyPath);
        // console.log(keyPath)
      },
      handleClick(tab, event) {
        // console.log(tab, event);
      },
      login(val) {
        this.userName = val
      },
      jumpMap() {
        this.$router.push({
          name: 'cxxqDj',
          query: {}
        })
      },
      jump(){
        this.$router.push({
          name: 'personalCenter',
          query: {}
        })
      },
    }
  };
</script>
<style>
  .tabbox .el-menu--horizontal>.el-menu-item.is-active {
    border: none
  }


  .el-menu--horizontal>.el-menu-item {
    color: #141b41;
  }

  .tabbox .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
  .tabbox .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
  .tabbox .el-menu--horizontal>.el-submenu .el-submenu__title:hover {
    background: none;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: none;
    height: 45px;
  }

  .tabbox .el-menu--horizontal>.el-menu-item {
    text-align: center;
    margin-left: 4%;
    /* width: 150px; */
    height: 100px;
    line-height: 100px;
    font-size: 22px;
    font-weight: 400;
    /* margin-right: 48px; */
    padding: 0;
  }

  .el-menu--horizontal>.el-menu-item {
    border-bottom: none;
    text-decoration: none;
  }

  .el-menu-demo .is-active span {
    padding: 5px 10px;
    position: relative;
    color: #3E79F6;
    border-bottom: 2px solid #0B3FAC;
    font-weight: bold;
  }

  .el-menu-bg .is-active span {
    padding: 5px 10px;
    position: relative;
    border-bottom: 2px solid #fff;
  }

  .tabbox .el-menu.el-menu--horizontal {
    border: none
  }
</style>
<style scoped>
  @media screen and (max-width: 1700px) {
    .bd_tit {
      display: none;
    }

    .el-menu--horizontal>.el-menu-item {
      font-size: 20px;
      margin-left: 3%;
    }
  }

  @media screen and (max-width: 1200px) {
    .bd_tit {
      display: none;
    }

    .el-menu--horizontal>.el-menu-item {
      font-size: 16px;
      margin-left: 2%;
    }
  }



  .bd_tit {
    font-size: 25px;
    font-weight: bold;
    color: #000000;
    line-height: 29px;
    width: 200px;
  }

  .menubox {
    /* display: flex;
  justify-content: center;
  align-content: center; */
    font-size: 22px;
    font-family: Microsoft YaHei-Bold, Microsoft YaHei;
    font-weight: 400;
    color: #3E4F57;
    line-height: 100px;
    height: 100px;
    width: 100%;
    top: 0;
    position: fixed;
    left: 0;
    z-index: 999;
    background-image: url('../../assets/images/69A3A3C4-D4DE-47cb-A411-9CE445F9E097.png');
    background-size: cover;
  }

  .el-menu {
    background: none;
    border-radius: 0px 0px 0px 0px;
    opacity: 1;

  }

  /* .el-submenu .el-submenu__title:hover {
  color: rgba(255, 134, 50, 1) !important;
  background-color: #fff !important;
} */
  .bg {
    background: #00203a;
  }

  .pageWith {
    /* width: 1200px;
                  min-width: 1200px; */
  }

  .pageFlexjusp {
    display: flex;
    justify-content: space-between;
  }

  .munHeight {
    height: 49px;
  }

  /* .flexCenter {
                  display: flex;
                  justify-content: flex-start !important;
                  align-items: center;
                } */

  /* .flexCenter:hover .titleClass {
                  color: rgb(0, 173, 169) !important;
                }
                .flexCenter:hover .el-icon-refresh {
                  color: rgb(0, 173, 169) !important;
                } */
  .logo {
    width: 70%;
    height: 70%;
    margin-right: 10px;
  }

  .tabbox {
    flex: 1;
    height: 100%;
    /* line-height: 49px; */
    color: #141b41;
    font-size: 15px;
  }

  el-menu-item {
    width: 150px;
    margin: 0 16px;
    text-align: center;
  }


  .el-menu-bg {
    background: none;
  }

  .loginbox {
    height: 100%;
    font-size: 18px;
    color: #141b41;
    /* position:fixed;
  //top:35px;
  right:20px; */
    /* margin-left: 80px; */
    cursor: pointer;
  }


  .loginHead img {
    width: 40px;
    height: 40px;
  }

  .loginbox .btn {
    width: 81px;
    height: 36px;
    color: #fff;
    background-color: #FDB62C;
  }

  .fontbg {
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/header/menu.vue